import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Table, Alert } from 'react-bootstrap';
import { API_URL } from '../../../utils/constants';
import '../AccountStyles.css';

function OwnersFindScreen() {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [hasSearched, setHasSearched] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) {
      setError('Please enter a search term');
      return;
    }

    setLoading(true);
    setError('');
    setHasSearched(true);

    try {
      const token = localStorage.getItem('token');
      const headers = {
        'Content-Type': 'application/json',
      };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      const response = await fetch(`${API_URL}/owners?search=${encodeURIComponent(searchTerm)}&limit=50`, { headers });
      if (response.ok) {
        const data = await response.json();
        setSearchResults(data.owners || []);
      } else {
        let errorData;
        try {
          errorData = await response.json();
        } catch {
          errorData = { message: `HTTP ${response.status}: ${response.statusText}` };
        }
        setError(errorData.message || `Error searching owners (${response.status})`);
      }
    } catch (error) {
      console.error('Error searching owners:', error);
      setError(`Error searching owners: ${error.message || 'Network error. Please check that the backend server is running.'}`);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setSearchTerm('');
    setSearchResults([]);
    setError('');
    setHasSearched(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <Container fluid className="account-screen">
      <Row>
        <Col>
          <h1 className="mb-4">Find Owners</h1>
          
          <Card className="mb-4">
            <Card.Body>
              <Form onSubmit={handleSearch}>
                <Row>
                  <Col md={8}>
                    <Form.Control
                      type="text"
                      placeholder="Search owners by name, number, or email..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Button type="submit" variant="primary" className="w-100" disabled={loading}>
                      {loading ? 'Searching...' : 'Search'}
                    </Button>
                  </Col>
                  <Col md={2}>
                    <Button variant="warning" onClick={handleClear} className="w-100" disabled={!hasSearched}>
                      Clear
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>

          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible className="mb-4">
              {error}
            </Alert>
          )}

          {hasSearched && !loading && (
            <Card>
              <Card.Header>
                <h5>Search Results ({searchResults.length} found)</h5>
              </Card.Header>
              <Card.Body>
                {searchResults.length === 0 ? (
                  <p className="text-muted">No owners found matching your search criteria.</p>
                ) : (
                  <Table responsive striped hover>
                    <thead>
                      <tr>
                        <th>Owner Number</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>City</th>
                        <th>Status</th>
                        <th>Create Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchResults.map((owner) => (
                        <tr key={owner.id}>
                          <td><strong>{owner.owner_number}</strong></td>
                          <td>{owner.name}</td>
                          <td>{owner.owner_type_name || 'N/A'}</td>
                          <td>{owner.email || 'N/A'}</td>
                          <td>{owner.phone1 || 'N/A'}</td>
                          <td>{owner.city || 'N/A'}</td>
                          <td>
                            <span className={`badge ${owner.active ? 'bg-success' : 'bg-secondary'}`}>
                              {owner.active ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td>{formatDate(owner.create_date)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default OwnersFindScreen;
